import React from "react";

function BeardMedium2() {
  return (
    <>
      <path
        className="hairMediumShade"
        d="m 373.68843,245.74409 -2.35454,8.96388 -0.76012,2.92928 v 0.0556 l -3.38347,12.97773 -3.8655,14.69264 -0.38934,1.5017 a 29.450155,29.450155 0 0 1 -28.50463,22.00649 H 182.55442 A 29.450155,29.450155 0 0 1 154.04978,286.86489 L 149.0719,267.834 142.69427,243.47296 v 1.10311 l 0.0834,10.13187 0.11124,16.37048 v 1.74272 l 0.11123,14.94292 v 0.53766 l 0.19467,24.75035 a 107.52967,107.52967 0 0 0 2.35453,21.74695 108.81818,108.81818 0 0 0 5.30232,17.51065 l 16.13873,40.58319 a 74.325257,74.325257 0 0 0 40.3329,41.10229 q 3.22589,1.34413 6.6001,2.40088 a 74.223288,74.223288 0 0 0 22.12701,3.37421 h 44.8751 a 74.380875,74.380875 0 0 0 69.0415,-46.87736 l 16.13873,-40.61099 a 107.14962,107.14962 0 0 0 5.03351,-16.29631 108.39177,108.39177 0 0 0 2.62334,-22.9613 l 0.21322,-26.7341 0.0927,-11.81899 v -2.36376 l 0.11123,-16.68565 v 0 l 0.0649,-8.13888 v -3.83773 z m -164.42771,88.74905 a 17.13059,17.13059 0 0 1 17.12131,-17.13057 h 64.25826 a 17.13986,17.13986 0 0 1 17.08424,17.13057 v 2.69752 a 17.13059,17.13059 0 0 1 -10.79932,15.91624 l -31.85103,12.66256 a 17.844365,17.844365 0 0 1 -13.16311,0 l -20.39357,-8.12035 v 0 l -11.39258,-4.53293 A 17.13059,17.13059 0 0 1 209.3256,337.19993 Z"
        id="path470"
      />
      <path
        className="hairDarkShade"
        d="m 176.4549,345.66326 c 0,0 3.32785,57.6767 54.13563,82.66808 0,0 -40.80566,-48.72207 -54.13563,-82.66808 z"
        id="path472"
      />
      <path
        className="hairDarkShade"
        d="m 220.0415,367.96639 c 0,0 -5.60823,29.83023 31.0909,60.36495 z"
        id="path474"
      />
      <path
        className="hairDarkShade"
        d="m 338.28705,345.66326 c 0,0 -3.32784,57.6767 -54.13562,82.66808 0,0 40.78712,-48.72207 54.13562,-82.66808 z"
        id="path476"
      />
      <path
        className="hairDarkShade"
        d="m 294.6912,367.96639 c 0,0 5.6175,29.83023 -31.08165,60.36495 z"
        id="path478"
      />
    </>
  );
}

export default BeardMedium2;
